module.exports = __webpack_public_path__ + "static/domed-labels-514d1c69db8e67ae3cf38bee5aef8f65.png";